import { useQueryClient } from '@tanstack/react-query';
import {
  API_ENDPOINT,
  useClientApiV1AccountsSlugConfirmUpdateMutation,
} from '../../resources/@types/accountSchema';
import { getUseUserProfileQueryKey } from '../hooks/useUserProfileQuery';
import { getAccountProfileQueryKey } from '../queries/useClientAccountProfileQuery';

interface UseClientV1AccountsSlugConfirmMutation {
  id: number;
  options?: Parameters<typeof useClientApiV1AccountsSlugConfirmUpdateMutation>[0]['options'];
}

export function useAccountsSlugConfirmUpdateMutation({
  id,
  options,
}: UseClientV1AccountsSlugConfirmMutation) {
  const queryClient = useQueryClient();
  return useClientApiV1AccountsSlugConfirmUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_SLUG_CONFIRM,
    options: {
      ...options,
      onSuccess: (...params) => {
        void queryClient.invalidateQueries(getAccountProfileQueryKey());
        void queryClient.invalidateQueries(getUseUserProfileQueryKey(id));
        options?.onSuccess?.(...params);
      },
    },
  });
}
